import { TranslationsKeys } from '../../../../i18n/i18n';
import {
  chargeAndGoLink,
  dkvMobilityLink,
  driverAppLink,
  utaEdenredLink,
} from '../../../../configuration/partnerLinks';
import dkvImage from '../../../../assets/images/overview/dkv-teaser.webp';
import edenredImage from '../../../../assets/images/overview/edenred.webp';
import chargeAndGoImage from '../../../../assets/images/overview/charge-and-go.webp';
import driverAppImage from '../../../../assets/images/overview/driver-app.webp';

export type Partner = {
  id: string;
  image: string;
  titleId: TranslationsKeys;
  descriptionId: TranslationsKeys;
  isExternalPartner: boolean;
  buildLink: (locale: string) => string;
};

export const PARTNERS: Partner[] = [
  {
    id: 'dkv-mobility',
    image: dkvImage,
    titleId: 'overview.ourPartners.dkvMobility.title',
    descriptionId: 'overview.ourPartners.dkvMobility.description',
    isExternalPartner: true,
    buildLink: dkvMobilityLink,
  },
  {
    id: 'uta-edenred',
    image: edenredImage,
    titleId: 'overview.ourPartners.utaEdenred.title',
    descriptionId: 'overview.ourPartners.utaEdenred.description',
    isExternalPartner: true,
    buildLink: utaEdenredLink,
  },
  {
    id: 'charge-and-go',
    image: chargeAndGoImage,
    titleId: 'overview.ourPartners.chargeAndGo.title',
    descriptionId: 'overview.ourPartners.chargeAndGo.description',
    isExternalPartner: false,
    buildLink: chargeAndGoLink,
  },
  {
    id: 'driver-app',
    image: driverAppImage,
    titleId: 'overview.ourPartners.driverApp.title',
    descriptionId: 'overview.ourPartners.driverApp.description',
    isExternalPartner: false,
    buildLink: driverAppLink,
  },
];
